import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { logAnalyticsDashboardView } from "../helpers/AnalyticsTags";
import PodcastAnalyticsDashboard from "./PodcastAnalyticsDashboard";

const PodcastAnalyticsPage = () => {
  const { podcastId } = useParams();

  useEffect(() => {
    logAnalyticsDashboardView({
      podcastId,
      pagePath: `/analytics/${podcastId}`,
    });
  }, [podcastId]);

  return (
    <PodcastAnalyticsDashboard
      title="Usage Analytics"
      podcastId={podcastId}
      storagePath={`Podcasts/${podcastId}/analytics/usage.csv`}
    />
  );
};

export default PodcastAnalyticsPage;
